import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { LocationCategoryDTO } from "src/app/features/locations-map/models/LocationCategoryDTO";
import { RouteSheet } from "src/app/features/locations-map/models/RouteSheet";
import { RouteSheetLocationDTO } from "src/app/features/locations-map/models/RouteSheetLocationDTO";
import { LayerService } from "src/app/features/locations-map/services/Layers.service";
import { LocationsService } from "src/app/features/locations-map/services/Locations.service";
import { PanelInternalLayerService } from "src/app/features/locations-map/services/Panel-Internal-Layer.service";
import { RouteSheetService } from "src/app/features/locations-map/services/RouteSheet.service";
import { RouteSheetUtilService } from "src/app/features/locations-map/services/RouteSheetUtil.service";
import { VirtualLocationsService } from "src/app/features/locations-map/services/VirtualLocations.service";
import { SwalNotificationService } from "src/app/features/shared/services/SwalNotification.service";
import { MapHelperService } from "src/services/map-helper.service";

@Component({
  selector: "app-route-sheet-list",
  templateUrl: "./route-sheet-list.component.html",
  styleUrls: ["./route-sheet-list.component.css"],
})
export class RouteSheetListComponent {
  @Input() identifier: string = "";
  @Input() childCategory: number = 0;
  @Input() parentCategory: number = 0;
  @Input() parentCoordX: string = "";
  @Input() parentCoordY: string = "";

  @Output() categoryTotal = new EventEmitter<string>();

  locationCategory: LocationCategoryDTO;
  parentLocationCategory: LocationCategoryDTO;

  locationRouteSheetListResponse: string = "";
  globalFinder: string = "";

  isRouteOrderFilterValue: boolean = false;
  RouteSheet: RouteSheet;
  originalShownLocationRouteSheetList: RouteSheetLocationDTO[] = [];
  shownLocationRouteSheetList: RouteSheetLocationDTO[] = [];
  mainItemList: RouteSheetLocationDTO[] = [];

  isShownLocationRouteSheetList: boolean = false;

  suscription_getDataKeyNames: Subscription;
  suscription_getImages: Subscription;
  suscription_updateRouteSheetLocations: Subscription;

  constructor(
    private dialog: MatDialog,
    public virtualLocationsService: VirtualLocationsService,
    public locationsService: LocationsService,
    public routeSheetService: RouteSheetService,
    private routeSheetUtilService: RouteSheetUtilService,
  ) {}

  ngOnInit(): void {
    this.locationCategory = JSON.parse(localStorage.getItem("listaCategorias")).find( (category) => { return category.id == this.childCategory; } );
    this.parentLocationCategory = JSON.parse(localStorage.getItem("listaCategorias")).find( (category) => { return category.id == this.parentCategory; } );
    this.getLocationsChildren();
    console.log("routesheetlist entre", this.locationCategory);
    
  }

  suscription_getRouteSheetList: Subscription;
  subscription_GetRouteListFiltered: Subscription;

  ngOnDestroy() {
    if (this.suscription_getRouteSheetList)
      this.suscription_getRouteSheetList.unsubscribe();
    if (this.subscription_GetRouteListFiltered)
      this.subscription_GetRouteListFiltered.unsubscribe();
    if (this.suscription_updateRouteSheetLocations)
      this.suscription_updateRouteSheetLocations.unsubscribe();

    // this.routeSheetUtilService.clearRouteToPointLayer();
    this.routeSheetService.dialogDetailsRef = null;
  }

  getLocationsChildren() {
    this.locationRouteSheetListResponse = "";
    // this.suscription_getRouteSheetList = this.virtualLocationsService.getChilds(this.identifier, this.childCategory).subscribe(data => {
    // const getRoute = (this.locationCategory.name == "Services" || this.locationCategory.name == "Servicios") ? true : false;
    this.suscription_getRouteSheetList = this.locationsService.GetRouteSheet(this.identifier, this.childCategory,"",true, this.isRouteOrderFilterValue, this.routeSheetService.isForceReload).subscribe(data => {
      if (data.isSuccess && data.result != null) {
        this.RouteSheet = data.result;
        const total = data.result.contador;

        this.mainItemList = this.RouteSheet.routeSheetList != null ? data.result.routeSheetList : [];
        this.originalShownLocationRouteSheetList = this.mainItemList;
        this.shownLocationRouteSheetList = this.mainItemList;

        this.categoryTotal.emit(total.toString());

        if (this.shownLocationRouteSheetList.length == 0) {
          this.locationRouteSheetListResponse = "No se encontaron activos asociados";
        }
        else{
          this.updateLayersMap();
        }
        this.routeSheetService.isForceReload = false;
      }else{
        this.locationRouteSheetListResponse = "No se encontraron activos asociados";
        this.shownLocationRouteSheetList = [];
        this.originalShownLocationRouteSheetList = [];
        this.mainItemList = [];
        this.categoryTotal.emit("0");
      }
    });
  }

  // getLocationsChildrenPage(page: number = 1) {
  //   this.locationRouteSheetListResponse = "";
  //   if (this.suscription_getRouteSheetList) {
  //     this.suscription_getRouteSheetList.unsubscribe();
  //   }
  //   this.suscription_getRouteSheetList = this.locationsService.GetRouteSheetPage(this.identifier, this.childCategory,this.globalFinder,true, this.isRouteOrderFilterValue, this.routeSheetService.isForceReload, page).subscribe(data => {
  //     if (data.isSuccess && data.result != null) {
  //       this.RouteSheet = data.result;
  //       const total = data.result.contador;

  //       this.originalShownLocationRouteSheetList = this.RouteSheet.routeSheetList != null ? data.result.routeSheetList : [];
  //       this.shownLocationRouteSheetList = this.RouteSheet.routeSheetList != null ? data.result.routeSheetList : [];

  //       this.categoryTotal.emit(total.toString());

  //       if (this.shownLocationRouteSheetList.length == 0) {
  //         this.locationRouteSheetListResponse = "No se encontaron activos asociados";
  //       }
  //       else{
  //         this.updateLayersMap();

  //         if (this.globalFinder.length == 0){
  //           var partialItemList = this.RouteSheet.routeSheetList != null ? data.result.routeSheetList : [];
  //           if (this.mainItemList.length == 0 || this.mainItemList == null) {
  //             this.mainItemList = partialItemList;
  //           }else{
  //             if (!this.mainItemList.some(item => item.identifierChild == partialItemList[0].identifierChild))
  //               this.mainItemList.push(partialItemList[0]);
  //           }
  //         }
  //       }
  //       this.routeSheetService.isForceReload = false;
  //     }else{
  //       if (this.mainItemList.length == 0 || this.shownLocationRouteSheetList.length == 0) {
  //         this.isShownLocationRouteSheetList = true;

  //       }
  //       this.locationRouteSheetListResponse = "No se encontaron activos asociados";
  //       this.shownLocationRouteSheetList = [];
  //       this.originalShownLocationRouteSheetList = [];
  //       this.mainItemList = [];
  //       this.categoryTotal.emit("0");
  //     }
  //   });
  // }

  async updateLayersMap() {
    await this.routeSheetUtilService.setRouteSheetLayers(this.RouteSheet.geoJSONRoute, this.RouteSheet.geoJSONCheckpoints, this.parentLocationCategory , this.locationCategory );
  }

  clickLocation(routeSheetLocation: RouteSheetLocationDTO): void {
    this.routeSheetService.openRouteSheetDetailsPopup(routeSheetLocation, this.parentCoordX, this.parentCoordY);
  }

  filter(filterValue: string) {
    this.routeSheetService.isLoadingList = true;
    this.globalFinder = filterValue;
    if (this.globalFinder.length > 0) {
      // this.shownLocationRouteSheetList = this.mainItemList.filter((item) => {
      //   return (item.identifierChild?.toLowerCase().includes(this.globalFinder.toLowerCase()) ||
      //           item.model?.toLowerCase().includes(this.globalFinder.toLowerCase()) ||
      //           item.description?.toLowerCase().includes(this.globalFinder.toLowerCase()) ||
      //           item.brand?.toLowerCase().includes(this.globalFinder.toLowerCase()));
      // });
      // if (this.shownLocationRouteSheetList.length == 0) {
      //   this.locationRouteSheetListResponse = "No hay resultados de búsqueda";
      // }
      // this.routeSheetService.isLoadingList = false;

      if (this.subscription_GetRouteListFiltered) {
        this.subscription_GetRouteListFiltered.unsubscribe();
      }
      this.locationRouteSheetListResponse = "";
      this.shownLocationRouteSheetList = [];
      this.subscription_GetRouteListFiltered = this.locationsService.GetRouteSheet(this.identifier, this.childCategory, this.globalFinder,false, this.isRouteOrderFilterValue, this.routeSheetService.isForceReload)
        .subscribe((data: any) => {
          if (data.isSuccess) {
            this.shownLocationRouteSheetList = data.result.routeSheetList;

            if (this.shownLocationRouteSheetList.length == 0)
              this.locationRouteSheetListResponse = "No hay resultados de búsqueda";
          }
          this.routeSheetService.isLoadingList = false;
        });

      // this.getLocationsChildrenPage(1);
    } else {
      if (this.subscription_GetRouteListFiltered) {
        this.subscription_GetRouteListFiltered.unsubscribe();
      }
      this.shownLocationRouteSheetList = this.mainItemList;
      this.routeSheetService.isLoadingList = false;
    }
  }

  drop(event: CdkDragDrop<RouteSheetLocationDTO[]>) {
    moveItemInArray(
      this.shownLocationRouteSheetList,
      event.previousIndex,
      event.currentIndex
    );
    for (let i = 0; i < this.shownLocationRouteSheetList.length; i++) {
      this.shownLocationRouteSheetList[i].noOrder = i + 1;
    }
  }

  refreshRelatedList() {
    this.shownLocationRouteSheetList = this.originalShownLocationRouteSheetList;
  }

  updateRelatedList() {
    //to do: esperar definicion
  }

  setOrder(order: boolean) {
    if (this.isRouteOrderFilterValue == order)
      return;
    this.isRouteOrderFilterValue = order;
    this.shownLocationRouteSheetList = [];
    this.getLocationsChildren();
  }

  forceReload() {
    this.routeSheetService.isForceReload = true;
    this.shownLocationRouteSheetList = [];
    this.getLocationsChildren();
  }

  onScroll(event: any): void {
    if(this.isShownLocationRouteSheetList || ((this.shownLocationRouteSheetList == null || this.shownLocationRouteSheetList.length <= 0) && this.locationRouteSheetListResponse == '')){
      return;
    }

    const element = event.target;
    if (element.scrollHeight - element.scrollTop <= (element.clientHeight + 10)) {
      this.loadMore();
    }
  }

  loadMore(): void {

    // se obtiene la página de tal forma que si hay números residuales, se vuelva a pedir desde la página con los residuos incluidos, para evitar lapsos
    var page = 0;
    var length = this.shownLocationRouteSheetList.length;
    var residue = length % 20;
    if (residue != 0) {
      page = Math.floor(length / 20);
      // si el numero de residuo es mayor a 0 pero el total menor a 10, dará 0, se suma 1 a la página para que se pida desde la primera
      if(page < 1){
        page = 1;
      }
    }else{
      page = (length / 20) + 1;
    }
    console.log('page', length, residue, page);
    // this.getLocationsChildrenPage(page);
  }
}
